const userAgent = navigator.userAgent || '';

const deviceUtils = {
  isPC() {
    return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  },

  isMobile() {
    return !this.isPC();
  },

  isWeChat() {
    return /MicroMessenger/i.test(userAgent);
  },

  isDAppBrowser() {
     return typeof window.ethereum !== 'undefined' || typeof window.tronWeb !== 'undefined';
  },

  isMetaMask() {
    return typeof window.ethereum !== 'undefined' && window.ethereum.isMetaMask === true;
  },

  isTronLink() {
    return typeof window.tronWeb !== 'undefined' && window.tronWeb.defaultAddress?.base58;
  },

  isOneKey() {
    return typeof window.okxwallet !== 'undefined' || userAgent.includes('OneKey');
  },

  isTokenPocket() {
    return /TokenPocket/i.test(userAgent);
  },

  isBitKeep() {
    return /BitKeep/i.test(userAgent) || typeof window.bitkeep !== 'undefined';
  },

  isImToken() {
    return /imToken/i.test(userAgent);
  },

  isMathWallet() {
    return /MathWallet/i.test(userAgent);
  }
};

export default deviceUtils;
